"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarOnEarth = void 0;
var GlobalEventName_1 = require("./GlobalEventName");
var PartyName_1 = require("../parties/PartyName");
var LogHelper_1 = require("../../LogHelper");
var WarOnEarth = (function () {
    function WarOnEarth() {
        this.name = GlobalEventName_1.GlobalEventName.WAR_ON_EARTH;
        this.description = 'Reduce TR 4 steps. Each influence prevents 1 step.';
        this.revealedDelegate = PartyName_1.PartyName.MARS;
        this.currentDelegate = PartyName_1.PartyName.KELVINISTS;
    }
    WarOnEarth.prototype.resolve = function (game, turmoil) {
        game.getPlayers().forEach(function (player) {
            var steps = Math.max(0, 4 - turmoil.getPlayerInfluence(player));
            player.decreaseTerraformRatingSteps(steps);
            LogHelper_1.LogHelper.logGlobalEventTRDecrease(player, steps);
        });
    };
    return WarOnEarth;
}());
exports.WarOnEarth = WarOnEarth;
//# sourceMappingURL=WarOnEarth.js.map